import { render, staticRenderFns } from "./CreateSurvey.vue?vue&type=template&id=4e38bc40&scoped=true"
import script from "./CreateSurvey.vue?vue&type=script&lang=js"
export * from "./CreateSurvey.vue?vue&type=script&lang=js"
import style0 from "./CreateSurvey.vue?vue&type=style&index=0&id=4e38bc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e38bc40",
  null
  
)

export default component.exports